module.exports = __webpack_public_path__ + "static/media/logoPost.4dfae3ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/brand/brands/actiway/media/logoPost.png
// module id = 860
// module chunks = 0